import React, { useCallback } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { IconButton } from 'components/Button';
import Model from '../../../../../model';

import './index.sass'

const { cnBlock, el } = bem('payment-balance-login-slug');
const PaymentBalanceLoginSlug = ({ className, mod }) => {

    const openLoginForm = useCallback(() => {
        Model.modal.openLoginForm({ redirect: null });
    }, [])

    return <div className={ cnBlock(className, mod) }>
        <div className={ el('slug') }>
            <div className={ el('stars') }>
                <Icon name={ 'stars' }/>
            </div>
            <div className={ el('content') }>
                <div className={ el('text') }>
                    <div className={ el('title', 'long-mod') }>
                        <Text serif>Оплата баллами</Text>
                    </div>
                    <div className={ el('label') }>
                        <Text>Войдите в свой аккаунт и платите баллами!</Text>
                    </div>
                </div>
                <div className={ el('button') }>
                    <IconButton name={ 'arrow-right' } mod={ 'transparent-gold' } type={ 'button' }
                                onClick={ openLoginForm }>
                        <Text>Войти</Text>
                    </IconButton>
                </div>
            </div>
        </div>
    </div>
}

export default PaymentBalanceLoginSlug;
